import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import CommonPagination from "components/CommonPagination";
import GKTable from "components/GKTable";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useNavigate } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";

const columns = [
  {
    headerName: "Company Name",
    field: "name",
    flex: 1,
    minWidth: 350,
    disableColumnMenu: true,
  },
  {
    headerName: "BSE Code",
    field: "bseCode",
    flex: 1,
    type: "number",
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "IsinCode",
    field: "isinCode",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "NSE Code",
    field: "nseCode",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
];

const UniqueCompany = () => {
  const navigate = useNavigate();

  const {
    state: { commonFilter },
  } = useAppContext();

  const requestBody = {
    take: commonFilter?.uniqueList?.take,
    skip: commonFilter?.uniqueList?.skip,
    sort: JSON.stringify(
      commonFilter?.uniqueList?.sortModel?.map((data) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.uniqueList?.search || "",
  };

  const { data, isFetching } = useQuery({
    queryKey: [QueryKeys.UNIQUE_COMPANY, requestBody],
    queryFn: () =>
      axiosInstance.get("/all-unique-company/", { params: requestBody }),
    onError: (error) => {},
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="advisorList"
        totalCount={data?.data?.totalCount || 0}
      />
    );
  };

  return (
    <DashboardLayout
      title="Company Master"
      breadcrumbs={[
        {
          name: "Company Master",
          path: "/app/company-master",
        },
        {
          name: "Unique Company",
          path: "",
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GKTable
            loading={isFetching}
            columns={columns}
            rows={data?.data?.data || []}
            maxHeight={"calc(100vh - 190px)"}
            searchPlaceholder="Search for unique"
            CustomPagination={!isFetching && cusPagination}
            onRowClick={(row) => {
              navigate(`/app/company-master/update/${row.row.gcode}`);
            }}
            pinnedColumns={{
              left: ["hierarchy", "name"],
            }}
            filterButton={false}
            zeroHolding
            name="uniqueList"
            tableName="unique_List"
          />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default UniqueCompany;
